import { LitElement, html, css } from 'lit';
import QRCode from 'qrcode';
import './PopupMessage.js';
import './DashboardAppQrCode.js';
import './DashboardAppAdSetting.js';

class DashboardAppMenuGroup extends LitElement {
  static get styles() {
    return css`
        :host {
            display: none; /* 初期状態では非表示 */
            text-align: center;
          }

        :host([visible]) {
            display: block; /* visible属性がtrueの時に表示 */
        }

        #url-container {
          display: flex;
          flex-direction: row;
        }

        button {
          display: flex;
          flex-direction: column;
          padding: 10px 20px;
          margin-right: 10px;
          font-size: 16px;
          border: none;
          border-radius: 50%;
          background-color: #007bff;
          color: white;
          cursor: pointer;
          transition: background-color 0.3s;
          width: 40px;
          height: 40px;
          align-items: center;
          justify-content: center;
        }

        button:not(:disabled):hover {
          background-color: #0056b3;
          filter: brightness(85%);
        }

        button div {
          font-size: 12px;
        }

        .setting {
          background-color: #22c72d;
        }

        .setting:hover {
          background-color: #199121 !important;
        }
        
    `;
  }

  //プロパティ設定
  static get properties() {
    return {
      visible: { type: Boolean },
      identKey: { type: String },
      appKey: { type: String },
    };
  }

  updated(changedProperties) {
    if (changedProperties.has('visible')) {
      this.visible ? this.setAttribute('visible', '') : this.removeAttribute('visible');
    }
  }

  constructor() {
    super();
    this.visible = true;
  }

  firstUpdated() {
    requestAnimationFrame(() => {
      const fontAwasomeStyle = document.querySelector(
        "link[rel='stylesheet'][data-name='fontawesomev6']"
      );
      const fontAwasomeStyleClone = fontAwasomeStyle.cloneNode(true);
      fontAwasomeStyleClone.removeAttribute('disabled');
      this.shadowRoot.insertBefore(fontAwasomeStyleClone, this.shadowRoot.firstChild);
    })
    this.show();
  }


  async show() {
    var options = {
      errorCorrectionLevel: 'H',
    };
    const url = `index.html`;
    QRCode.toCanvas(this.shadowRoot.getElementById('qrcode'), url, options);
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  createUrl() {
    return process.env.APP_URL_BASE.replace('%s', `${this.appKey}-${this.identKey}`);
  }

  openUrl(event) {
    //const url = process.env.APP_URL_BASE + this.identKey + '/' + this.appKey + '/';
    const url = this.createUrl();
    //urlを開く
    window.open(url);
  }

  copyUrl(event) {
    //const url = process.env.APP_URL_BASE + this.identKey + '/' + this.appKey + '/' + 'index.html';
    //const url = process.env.APP_URL_BASE + this.identKey + '/' + this.appKey + '/';
    const url = this.createUrl();
    navigator.clipboard.writeText(url);

    //ポップアップを作成
    const popupMessage = document.createElement('popup-message-element');
    //event.targetの絶対位置X,Yを取得
    const rect = event.target.closest('#url-copy').getBoundingClientRect();
    popupMessage.style.left = rect.left + 'px';
    popupMessage.style.top = rect.top - 30 + 'px';
    popupMessage.style.position = 'fixed';
    popupMessage.style.fontSize = '16px;';
    popupMessage.message = 'URLをコピーしました';
    this.shadowRoot.appendChild(popupMessage);
    popupMessage.show();

    //ツールチップを削除
    setTimeout(() => {
      popupMessage.hide();
      this.shadowRoot.removeChild(popupMessage);
    }, 1000);
  }

  showQrCode(event) {
    //const url = process.env.APP_URL_BASE + this.identKey + '/' + this.appKey + '/';
    const url = this.createUrl();
    //ポップアップを作成
    const appQr = document.createElement('dashboard-app-qrcode');
    // appQr.identKey = this.identKey;
    // appQr.appKey = this.appKey;
    this.shadowRoot.appendChild(appQr);
    appQr.show(url);
  }

  showAdSetting(event) {
    //ポップアップを作成
    const adSetting = document.createElement('dashboard-app-ad-setting');
    adSetting.identKey = this.identKey;
    adSetting.appKey = this.appKey;
    this.shadowRoot.appendChild(adSetting);
    adSetting.show();
  }

  render() {
    return html`
          <div id="url-container">
            <div id="url-open" style="font-size:14px;">
              <button @click="${this.openUrl}" title="アプリを開く">
                <i class="fa-regular fa-window-maximize"></i>
                <div>OPEN</div>
              </button>
            </div>

            <div id="url-copy" style="font-size:14px;">
              <button @click="${this.copyUrl}" title="アプリのURLをクリップボードにコピー">
                <i class="fa-regular fa-clipboard"></i>
                <div>URL</div>
              </button>
            </div>

            <div id="url-qr" style="font-size:14px;">
              <button @click="${this.showQrCode}" title="アプリのQRコードを表示">
                <i class="fa-solid fa-qrcode"></i>
                <div>QR</div>
              </button>
            </div>
            <!--
            <div id="ad-setting" style="font-size:14px;">
              <button @click="${this.showAdSetting}" class="setting"  title="広告設定を表示">
                <i class="fa-solid fa-gear"></i>
                <div>AD</div>
              </button>
            </div>
            -->
            
          </div>
    `;
  }
}

customElements.define('dashboard-app-menu-group', DashboardAppMenuGroup);
